import React, { Component, Fragment } from 'react';
import {  Button, MenuItem, TextField, Container, Grid, Card, Tabs, Tab, Typography, Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText } from '@material-ui/core/';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import isEmpty from 'lodash.isempty';
import OverLoader from './common/loader'
import {
  CreateCustomer, GetCustomer, EditCustomer, GetCustomerContacts, EditCustomerContact,
  CreateCustomerContact, DeleteCustomerContact, LogoutAction
} from '../actions';
import { connect } from 'react-redux';
import { Prompt } from "react-router-dom";
import SideSearchbar from './SideSearchbar';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && <Card className="p-40">{children}</Card>}
    </Typography>
  );
}

class Customer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMessage:'',
      isCountryEmpty: false,
      isCustomerNameEmpty: false,
      selectedCustomer: [],
      filterdContactList: [],
      isFirstNameEmpty: false,
      emailValidate: true,
      emailValidateForCustomer: true,
      createContactEmailValidate: true,
      IsEditContactNachNameEmpty: false,
      isBlocking: false,
      editMode: false,
      filterField: '',
      filtered: [],
      name: "",
      short_name: "",
      active: "1",
      country_id: "",
      street: "",
      zipcode: "",
      city: "",
      mail: "",
      phone: "",
      fax_no: "",
      comment: "",
      customerId: '',
      currentTab: 0,
      isContactEditDialogOpen: false,
      editContactId: '',
      editContactFirstName: '',
      editContactlastName: '',
      editContactActive: true,
      editContactAnrede: '',
      editContactTitel: '',
      editContactFunktion: '',
      editContactTelefon: '',
      editContactEmail: '',
      isContactCreateDialogOpen: false,
      createContactFirstName: '',
      createContactlastName: '',
      createContactActive: true,
      createContactAnrede: '',
      createContactTitel: '',
      createContactFunktion: '',
      createContactTelefon: '',
      createContactEmail: '',
      editedCustomer: '',
      newCustomer:'',
      isDeleteContactDialogOpen: false,
      deleteContactId: '',
      customerListDirection:'asc'
    }
    this.baseState = this.state;
    this.textInput = React.createRef();
    this.contactInput = React.createRef();

  }

  focusTextInput = () => {
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (Number(access_rights.customers) === 2 && token !== null) {
      this.textInput.current.focus();
    }
  }
  focusContactInput =()=> {
    this.contactInput.current.focus();
  }

  componentDidMount = () => {
    const { GetCustomer } = this.props
    this.focusTextInput()
    GetCustomer();
  }

  componentWillReceiveProps(nextProps) {

    const { filterdContactList, deleteContactId } = this.state
    const { newCustomerContact, editedCustomerContact, deleteSuccess, error_validation, customerList, editedCustomer, newCustomer } = this.props
    if (nextProps.editedCustomerContact !== editedCustomerContact) {
      let resulted = filterdContactList.map(item => {
        if (item.id === nextProps.editedCustomerContact.id) {
          item = nextProps.editedCustomerContact
        }
        return item
      })
      this.setState({ filterdContactList: resulted, isBlocking: false, })

    } else if (nextProps.editedCustomer !== editedCustomer ) {
      this.setState({ editedCustomer: nextProps.editedCustomer, isBlocking: false, })
      
    }
    else if (nextProps.newCustomer !== newCustomer) {
      this.setState({ customerId: nextProps.newCustomer.id, isBlocking: false, editMode: true, newCustomer: nextProps.newCustomer, filterdContactList:[] })
    }
    else if (nextProps.newCustomerContact !== newCustomerContact) {
      filterdContactList.push(nextProps.newCustomerContact)
      this.setState({ filterdContactList: filterdContactList, isBlocking: false, })
    }
    else if (nextProps.customerList !== customerList) {
      this.setState({
        filtered: nextProps.customerList,
      });

    } else if (nextProps.deleteSuccess !== deleteSuccess) {
      let indexOf = ''
      let resulted = filterdContactList.map((item, index) => {
        if (item.id === deleteContactId) {
          indexOf = index
        }
        return item
      })
      resulted.splice(indexOf, 1)
      this.setState({ filterdContactList: resulted, isBlocking: false, })
    }
    else if (nextProps.error_validation !== error_validation) {
      this.setState({ errorMessage: nextProps.error_validation })
    }
  }

  resetForm = () => {
    this.baseState.filtered = this.props.customerList;
    this.setState(this.baseState);
    setTimeout(() => {
      this.focusTextInput()
    },100)
  }

  getFilterdData = (item) => {
    const { isBlocking} = this.state
    if (!isBlocking) {
      let countryCode = ''
      if (item.country_id !== null) {
        countryCode = item.country_id
      }
      this.setState({
        selectedCustomer: item,
        filterdContactList: item.customer_contacts,
        editMode: true,
        name: item.name,
        short_name: item.shortname,
        active: item.active,
        country_id: countryCode,
        street: item.street,
        zipcode: item.zipcode,
        city: item.city,
        mail: item.mail,
        phone: item.phone,
        fax_no: item.faxno,
        comment: item.comment,
        customerId: item.id,
        errorMessage: '',
        currentTab: 0,
      })
      setTimeout(() => {
        this.focusTextInput()
      }, 200)
    } else {
      let retVal = window.confirm("Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren?");

      if (retVal === true) {
        this.setState({ isBlocking: false }, () => this.getFilterdData(item))
      } else {
        this.setState({ isBlocking: false }, () => setTimeout(() => {
          this.setState({ isBlocking: true })
        }, 1000))
      }
    }
  }

  createCustomer = () => {
    const { CreateCustomer, EditCustomer } = this.props
    const { customerId, editMode, name, short_name, active, country_id, street, zipcode, city, mail, phone, fax_no, comment } = this.state;
    // if (name !== '' && country_id !== "") {
      if (editMode) {
        EditCustomer(customerId, name, short_name, active, country_id, street, zipcode, city, mail, phone, fax_no, comment)
      } else {
        CreateCustomer(name, short_name, active, country_id, street, zipcode, city, mail, phone, fax_no, comment)
      }
  // } 
    // else {
    //   if(name === '')
    //     this.setState({ isCustomerNameEmpty: true })
    //   else if (name === '' && country_id === '')
    //     this.setState({ isCustomerNameEmpty: true, isCountryEmpty: true })
    //   else
    //     this.setState({ isCountryEmpty: true})
    // }
  }

  emailCustomerValidate = () => {
    const { mail } = this.state
    let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (mail.match(mailformat) || mail === '' ) {
      this.setState({ emailValidateForCustomer: true })
      this.createCustomer()
    }  else {
      this.setState({ emailValidateForCustomer: false })
      }
    }
  

  handleTabChange = (e, newTabIndex) => {
    const { editMode, isBlocking } = this.state
    if (editMode)
      if (!isBlocking)
        this.setState({ currentTab: newTabIndex })
      else {
        let retVal = window.confirm("Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren?");

        if (retVal === true) {
          this.setState({ isBlocking: false, currentTab: newTabIndex })
        } else {
          this.setState({ isBlocking: false }, () => setTimeout(() => {
            this.setState({ isBlocking: true })
          }, 100))
        }
      }
      }
       
  handleCountrySelect = (e) => {
    this.setState({ country_id: e.target.value, isBlocking: true,isCountryEmpty: false})
  }
  handleEditAnredeSelect = (e) => {
    this.setState({ editContactAnrede: e.target.value })
  }
  handleEditTitelSelect = (e) => {
    this.setState({ editContactTitel: e.target.value })
  }
  handleCreateAnredeSelect = (e) => {
    this.setState({ createContactAnrede: e.target.value })
  }
  handleCreateTitelSelect = (e) => {
    this.setState({ createContactTitel: e.target.value })
  }

  launchEditContactDialog = (e, contactPersonDetails) => {
    this.setState({
      editContactId: contactPersonDetails.id,
      editContactFirstName: contactPersonDetails.firstname,
      editContactlastName: contactPersonDetails.lastname,
      editContactActive: contactPersonDetails.active,
      editContactAnrede: contactPersonDetails.salutation,
      editContactTitel: contactPersonDetails.title,
      editContactFunktion: contactPersonDetails.function,
      editContactTelefon: contactPersonDetails.phone,
      editContactEmail: contactPersonDetails.mail,
      isContactEditDialogOpen: true
    });
    setTimeout(() => {
      this.focusContactInput()
    }, 100)
  }

  launchCreateContactDialog = () => {
    this.setState({ isContactCreateDialogOpen: true });
    setTimeout(() => {
      this.focusContactInput()
    }, 100)
  }

  launchDeleteContactDialog = (e, deleteContactId) => {
    this.setState({ isDeleteContactDialogOpen: true, deleteContactId });
  }

  createContactAndCloseDialog = () => {

    const { customerId, createContactFirstName, createContactlastName, createContactActive, createContactAnrede, createContactTitel, createContactFunktion, createContactTelefon, createContactEmail } = this.state;

    this.props.CreateCustomerContact(customerId, createContactFirstName, createContactlastName, createContactActive, createContactAnrede, createContactTitel, createContactFunktion, createContactTelefon, createContactEmail);
    this.setState({
      createContactFirstName: '',
      createContactlastName: '',
      createContactActive: true,
      createContactAnrede: '',
      createContactTitel: '',
      createContactFunktion: '',
      createContactTelefon: '',
      createContactEmail: '',
      isContactCreateDialogOpen: false,
    });
  }

  ValidateContactCustomerForm = () => {

    const { createContactEmail, createContactlastName } = this.state
    let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if ((createContactEmail.match(mailformat) || createContactEmail === '') && createContactlastName !== '') {
      this.setState({ emailValidate: true, isFirstNameEmpty: false })
      this.createContactAndCloseDialog()
    } else {
      if (((!createContactEmail.match(mailformat) && !isEmpty(createContactEmail)) && createContactlastName === '')) {
        this.setState({ emailValidate: false, isFirstNameEmpty: true })
      }
      else if ((createContactlastName === '' && createContactEmail.match(mailformat)) || isEmpty(createContactEmail)) {
        this.setState({ isFirstNameEmpty: true, emailValidate: true })
      } else {
        this.setState({ emailValidate: false, isFirstNameEmpty: false })
      }
    }

  }

  ValidateEditContactCustomerForm = () => {

    const { editContactEmail, editContactlastName } = this.state
    let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if ((editContactEmail.match(mailformat) || editContactEmail === "") && editContactlastName !== '') {
      this.setState({ createContactEmailValidate: true, IsEditContactNachNameEmpty: false })
      this.updateContactAndCloseDialog()
    } else {
      if (((!editContactEmail.match(mailformat) && !isEmpty(editContactEmail)) && editContactlastName === '')) {
        this.setState({ createContactEmailValidate: false, IsEditContactNachNameEmpty: true })
      }
      else if (editContactlastName === '' && (editContactEmail.match(mailformat) || isEmpty(editContactEmail))) {
        this.setState({ IsEditContactNachNameEmpty: true, createContactEmailValidate: true })
      } else {
        this.setState({ createContactEmailValidate: false, IsEditContactNachNameEmpty: false })
      }
    }

  }

   sortDesc =(list, key)=> {
  let sorted = list.slice().sort((obj1, obj2) => {
    if (obj1[key] < obj2[key]) return 1;
    if (obj1[key] > obj2[key]) return -1;
    return 0;
  });
  return sorted;
}

 sortAsc=(list, key)=> {
  let sorted = list.slice().sort((obj1, obj2) => {
    if (obj1[key] > obj2[key]) return 1;
    if (obj1[key] < obj2[key]) return -1;
    return 0;
  });
  return sorted;
}

  sortingContactList = (key) => {
    
    const { customerListDirection, filterdContactList } = this.state
    let newList = [], dir = customerListDirection;
    if (customerListDirection === 'asc') {
      newList = this.sortDesc(filterdContactList, key);
      dir = 'desc';
    } else {
      newList = this.sortAsc(filterdContactList, key)
      dir = 'asc';
    }
    
    this.setState({ filterdContactList: newList, customerListDirection:dir })
  }


  closeCreateContactDialog = () => {
    this.setState({
      createContactActive: true,
      emailValidate: true,
      isFirstNameEmpty: false,
      isContactCreateDialogOpen: false,
      createContactFirstName: '',
      createContactlastName: '',
      createContactAnrede: '',
      createContactTitel: '',
      createContactFunktion: '',
      createContactTelefon: '',
      createContactEmail: '',
    });
  }

  closeDeleteContactDialog = () => {
    this.setState({ isDeleteContactDialogOpen: false })
  }

  deleteContactAndCloseDialog = () => {
    this.props.DeleteCustomerContact(this.state.deleteContactId);
    this.setState({ isDeleteContactDialogOpen: false })
  }

  updateContactAndCloseDialog = () => {
    const { customerId, editContactId, editContactFirstName, editContactlastName, editContactActive, editContactAnrede, editContactTitel, editContactFunktion, editContactTelefon, editContactEmail } = this.state;
    this.props.EditCustomerContact(customerId, editContactId, editContactFirstName, editContactlastName, editContactActive, editContactAnrede, editContactTitel, editContactFunktion, editContactTelefon, editContactEmail);
    this.setState({ isContactEditDialogOpen: false });
  }

  closeEditContactDialog = () => {
    this.setState({ createContactEmailValidate: true, IsEditContactNachNameEmpty: false, isContactEditDialogOpen: false })
  }

  render() {
    const { isloading, lands_list } = this.props;
    const {
      filterdContactList,
      emailValidate,
      isFirstNameEmpty,
      IsEditContactNachNameEmpty,
      editMode,
      filtered,
      name,
      short_name,
      active,
      country_id,
      street,
      zipcode,
      mail,
      phone,
      fax_no,
      comment,
      currentTab,
      city,
      isContactEditDialogOpen,
      editContactFirstName,
      editContactlastName,
      editContactActive,
      editContactAnrede,
      editContactTitel,
      editContactFunktion,
      editContactTelefon,
      editContactEmail,
      isContactCreateDialogOpen,
      createContactFirstName,
      createContactlastName,
      createContactActive,
      createContactAnrede,
      createContactTitel,
      createContactFunktion,
      createContactTelefon,
      createContactEmail,
      isDeleteContactDialogOpen,
      createContactEmailValidate,
      emailValidateForCustomer,
      errorMessage,
      editedCustomer,
      newCustomer,
      isBlocking
       } = this.state;
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div className="customer-main-page">
        {isloading && <OverLoader />}
        <Container maxWidth="xl">
          <Grid container spacing={3} className="mainBlock">
            <Grid item md={3} sm={4} xs={12}>
          <div className="leftSide">
            <SideSearchbar
              tittle={"Neuer Kunde"}
              listData={filtered}
              newList={newCustomer}
              editedList={editedCustomer}
              // deleteList={dataObj.deletedProject}
              getDataOfSelectedItemFunc={this.getFilterdData}
              createNewListFunc={this.resetForm}
              activeField={true}
              isRight={Number(access_rights.customers)}
            />
            </div>
            </Grid>
            <Grid item md={9} sm={8} xs={12} className="customer-right">
              <Prompt
                when={isBlocking}
                message={location =>
                  `Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren? `
                }
              />
            <Tabs
              value={currentTab}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary">
              <Tab label="Kundenstammdaten" />
              <Tab label="Ansprechpersonen" />
            </Tabs>
            <TabPanel value={currentTab} index={0}>
              <Grid container spacing={1} style={Number(access_rights.customers) === 1 ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                <Grid item xs={9}>
                  <Grid container spacing={1} justify="center">
                    <Grid item xs={2} style={{ paddingTop: '10px'}}>
                      Kunde
                    </Grid>
                    <Grid item xs={10}>
                      <TextField inputProps={{
                        maxLength: 60
                      }}
                        helperText={!isEmpty(errorMessage.name) ? errorMessage.name : ''} error={!isEmpty(errorMessage.name) ? true : false}
                        inputRef={this.textInput}
                        required fullWidth size="small" value={name}
                        onChange={(e) => {
                          if (!isEmpty(errorMessage.name))
                            errorMessage.name= ''
                          this.setState({ name: e.target.value,isBlocking: true, })
                        }} variant="outlined" />
                    </Grid>
                    <Grid item xs={2} style={{ paddingTop: '10px'}}>
                      Kurzname
                    </Grid>
                    <Grid item xs={10}>
                      <TextField
                        inputProps={{
                          maxLength: 20
                        }}
                        helperText={!isEmpty(errorMessage.shortname) ? errorMessage.shortname : ''}
                        error={!isEmpty(errorMessage.shortname) ? true : false}  
                        required fullWidth size="small" value={short_name} 
                        onChange={(e) => { 
                          if (!isEmpty(errorMessage.shortname))
                            errorMessage.shortname = '' 
                          this.setState({ short_name: e.target.value,isBlocking: true, })
                          }} variant="outlined" />
                    </Grid>
                    <Grid item xs={2} style={{ paddingTop: '10px'}}>
                      aktiv
                    </Grid>
                    <Grid item xs={10}>
                      <Checkbox
                        // style={{ padding: "0px" }}
                        checked={Boolean(active)}
                        color="primary"
                        // size="small"
                        onChange={(e) => this.setState({ active: !active })}
                      />

                    </Grid>
                    <Grid item xs={2} style={{ paddingTop: '10px'}}>
                      Land
                    </Grid>
                    <Grid item xs={10}>
                      <TextField
                        helperText={!isEmpty(errorMessage.country) ? errorMessage.country : ''}
                        error={!isEmpty(errorMessage.country) ? true : false}  
                        value={country_id}
                        select
                        variant="outlined"
                        className="select-box"
                        size="small"
                        fullWidth
                        onChange={(e) => {
                          if (!isEmpty(errorMessage.country))
                            errorMessage.country = ''
                          this.handleCountrySelect(e)
                        }}
                      >
                        {lands_list && 
                          lands_list.map((item, index) => (
                            <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                          ))
                        }
                        
                      </TextField>
                    </Grid>
                    <Grid item xs={2} style={{ paddingTop: '10px'}}>
                      Straße, Hausnr.
                    </Grid>
                    <Grid item xs={10}>
                      <TextField
                        inputProps={{
                          maxLength: 60
                        }}  disabled={country_id === '' ? true : false} required fullWidth size="small" value={street} onChange={(e) => this.setState({ street: e.target.value,isBlocking: true, })} variant="outlined" />
                    </Grid>
                    <Grid item xs={2} style={{ paddingTop: '10px'}}>
                      PLZ / Ort
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        inputProps={{
                          maxLength: 10
                        }}
                        required disabled={country_id === '' ? true : false} fullWidth size="small" value={zipcode} onChange={(e) => this.setState({ zipcode: e.target.value,isBlocking: true, })} variant="outlined" />
                    </Grid>
                    <Grid item xs={8}>
                      <TextField required
                        inputProps={{
                          maxLength: 60
                        }}
                        disabled={country_id === '' ? true : false} fullWidth size="small" value={city} onChange={(e) => this.setState({ city: e.target.value,isBlocking: true, })} variant="outlined" />
                    </Grid>
                    <Grid item xs={2} style={{ paddingTop: '10px'}}>
                      eMail
                    </Grid>
                    <Grid item xs={10}>
                      <TextField required helperText={!emailValidateForCustomer ? "eMail ist keine E-Mail-Adresse" : ''} error={emailValidateForCustomer ? false : true} fullWidth size="small" value={mail} onChange={(e) => this.setState({ mail: e.target.value,isBlocking: true, emailValidateForCustomer:true })} variant="outlined" />
                    </Grid>
                    <Grid item xs={2} style={{ paddingTop: '10px'}}>
                      Telefon
                    </Grid>
                    <Grid item xs={10}>
                      <TextField
                        inputProps={{
                          maxLength: 40
                        }}
                        required fullWidth size="small" value={phone} onChange={(e) => this.setState({ phone: e.target.value,isBlocking: true, })} variant="outlined" />
                    </Grid>
                    <Grid item xs={2} style={{ paddingTop: '10px'}}>
                      Fax
                    </Grid>
                    <Grid item xs={10}>
                      <TextField
                        inputProps={{
                          maxLength: 40
                        }}
                        required fullWidth size="small" value={fax_no} onChange={(e) => this.setState({ fax_no: e.target.value,isBlocking: true, })} variant="outlined" />
                    </Grid>
                    <Grid item xs={2} style={{ paddingTop: '10px'}}>
                      Notizen
                    </Grid>
                    <Grid item xs={10}>
                      <TextField required fullWidth multiline rows={5} rowsMax={Infinity} variant="outlined" value={comment} onChange={(e) => this.setState({ comment: e.target.value,isBlocking: true, })} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <br />
              <br />
              {Number(access_rights.customers) !== 1 &&
              <Fragment>
              {editMode ?
                <Button variant="outlined" color="primary" className="m-10" onClick={() => { this.emailCustomerValidate() }} >Speichern</Button>
                :
                <Button variant="outlined" color="primary" className="m-10" onClick={() => { this.emailCustomerValidate() }} >Hinzufügen</Button>
                }
              </Fragment>
            }
            </TabPanel>
            <TabPanel value={currentTab} index={1}>
              <div style={Number(access_rights.customers) === 1 ? { pointerEvents: "none", opacity: "0.4" } : {}}>
              <div style={{marginBottom:"15px"}}>
              <span style={{display:"inline-block", marginRight:"30px", opacity:"0.6", paddingTop:"10px"}}>Kunde</span>
                <TextField style={{minWidth: 500 }} disabled size="small" value={name} variant="outlined" />
                </div>
                {Number(access_rights.customers) !== 1 &&
                  <Button variant="outlined" color="primary" onClick={this.launchCreateContactDialog} size="large">Ansprechperson hinzufügen</Button>
                }
                <Typography variant="h1" gutterBottom />

              <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ width: '10vw' }}></TableCell>
                      <TableCell style={{ cursor: "pointer" }} onClick={() => this.sortingContactList("lastname")}>
                        Nachname
                      </TableCell>
                      <TableCell style={{ cursor: "pointer" }} onClick={() => this.sortingContactList("firstname")}>Vorname
                      
                      </TableCell>
                      <TableCell onClick={() => this.sortingContactList("title")}>Titel
                      
                      </TableCell>
                      <TableCell onClick={() => this.sortingContactList("function")}>Funktion</TableCell>
                      <TableCell>Telefon</TableCell>

                    </TableRow>
                  </TableHead>
                  {
                    !isEmpty(filterdContactList) &&
                    <TableBody>
                      {filterdContactList.map((row, index) => {
                        return (
                          <TableRow  hover role="checkbox" tabIndex={-1} key={index}>
                            <TableCell style={{ padding: "8px 16px" }}>
                              <IconButton onClick={(e) => this.launchEditContactDialog(e, row)}>
                                <EditIcon />
                              </IconButton>
                              <IconButton onClick={(e) => this.launchDeleteContactDialog(e, row.id)} >
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                            <TableCell>
                              {row.lastname}
                            </TableCell>
                            <TableCell>
                              {row.firstname}
                            </TableCell>
                            <TableCell>
                              {row.title}
                            </TableCell>
                            <TableCell>
                              {row.function}
                            </TableCell>
                            <TableCell>
                              {row.phone}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  }
                </Table>
              </TableContainer>
              </div>
            </TabPanel>
          </Grid>
        </Grid>

        <Dialog open={isContactEditDialogOpen} maxWidth="sm">
          <DialogTitle id="form-dialog-title">Ansprechperson bearbeiten</DialogTitle>
          <DialogContent className="p-60">

            <Grid container spacing={1} justify="center">
              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                Nachname
              </Grid>
              <Grid item xs={10}>
                  <TextField
                    helperText={IsEditContactNachNameEmpty ? "Nachname darf nicht leer sein" : ''} error={IsEditContactNachNameEmpty ? true : false}
                    fullWidth size="small" inputRef={this.contactInput} value={editContactlastName} onChange={(e) => this.setState({ editContactlastName: e.target.value, IsEditContactNachNameEmpty: false })} variant="outlined" />
              </Grid>
              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                Vorname
              </Grid>
              <Grid item xs={10}>
                  <TextField
                    fullWidth size="small" value={editContactFirstName}
                  onChange={(e) => this.setState({ editContactFirstName: e.target.value })} variant="outlined" />
              </Grid>
              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                aktiv
              </Grid>
              <Grid item xs={10}>
                <Checkbox
                  // style={{ padding: "0px" }}
                  checked={Boolean(editContactActive)}
                  color="primary"
                  // size="small"
                  onChange={(e) => this.setState({ editContactActive: !editContactActive })}
                />

              </Grid>
              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                Anrede
              </Grid>
              <Grid item xs={10}>
                <TextField
                  value={editContactAnrede}
                  select
                  variant="outlined"
                  className="select-box"
                  size="small"
                  fullWidth
                  onChange={(e) => this.handleEditAnredeSelect(e)}
                >
                  <MenuItem value={'Frau'}>Frau</MenuItem>
                  <MenuItem value={'Herr'}>Herr</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                Titel
              </Grid>
              <Grid item xs={10}>
                <TextField required fullWidth size="small" value={editContactTitel} onChange={(e) => this.handleEditTitelSelect(e)} variant="outlined" />
              </Grid>

              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                Funktion
              </Grid>
              <Grid item xs={10}>
                <TextField required fullWidth size="small" value={editContactFunktion} onChange={(e) => this.setState({ editContactFunktion: e.target.value })} variant="outlined" />
              </Grid>
              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                Telefon
              </Grid>
              <Grid item xs={10}>
                <TextField required fullWidth size="small" value={editContactTelefon} onChange={(e) => this.setState({ editContactTelefon: e.target.value })} variant="outlined" />
              </Grid>
              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                eMail
              </Grid>
              <Grid item xs={10}>
                <TextField required helperText={!createContactEmailValidate ? "eMail ist keine E-Mail-Adresse" : ''} error={createContactEmailValidate ? false : true} fullWidth size="small" value={editContactEmail} onChange={(e) => this.setState({ editContactEmail: e.target.value, createContactEmailValidate: true})} variant="outlined" />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button variant="outlined"  className="m-10" onClick={this.ValidateEditContactCustomerForm} color="primary">
              Speichern
            </Button>
            <Button variant="outlined"  className="m-10" onClick={this.closeEditContactDialog} color="secondary">
              Abbrechen
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={isContactCreateDialogOpen} maxWidth="sm">
          <DialogTitle id="form-dialog-title">Ansprechperson hinzufügen</DialogTitle>
          <DialogContent className="p-60">

            <Grid container spacing={1} justify="center">
              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                Nachname
              </Grid>
              <Grid item xs={10}>
                  <TextField
                    helperText={isFirstNameEmpty ? "Nachname darf nicht leer sein" : ''} error={isFirstNameEmpty ? true : false}
                    required fullWidth size="small" inputRef={this.contactInput} value={createContactlastName} onChange={(e) => this.setState({ createContactlastName: e.target.value, isFirstNameEmpty: false  })} variant="outlined" />
              </Grid>
              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                Vorname
              </Grid>
              <Grid item xs={10}>
                  <TextField
                    // helperText={isFirstNameEmpty ? "Vorname darf nicht leer sein" : ''} error={isFirstNameEmpty ? true : false}
                    required fullWidth size="small" value={createContactFirstName}
                  onChange={(e) => this.setState({ createContactFirstName: e.target.value})} variant="outlined" />
              </Grid>
              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                aktiv
              </Grid>
              <Grid item xs={10}>
                <Checkbox
                  // style={{ padding: "0px" }}
                  checked={Boolean(createContactActive)}
                  color="primary"
                  // size="small"
                  onChange={(e) => this.setState({ createContactActive: !createContactActive })}
                />

              </Grid>
              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                Anrede
              </Grid>
              <Grid item xs={10}>
                <TextField
                  value={createContactAnrede}
                  select
                  variant="outlined"
                  className="select-box"
                  size="small"
                  fullWidth
                  onChange={(e) => this.handleCreateAnredeSelect(e)}
                >
                  <MenuItem value={'Frau'}>Frau</MenuItem>
                  <MenuItem value={'Herr'}>Herr</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                Titel
              </Grid>
              <Grid item xs={10}>
                <TextField required fullWidth size="small" value={createContactTitel} onChange={(e) => this.handleCreateTitelSelect(e)} variant="outlined" />
              </Grid>

              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                Funktion
              </Grid>
              <Grid item xs={10}>
                <TextField required fullWidth size="small" value={createContactFunktion} onChange={(e) => this.setState({ createContactFunktion: e.target.value })} variant="outlined" />
              </Grid>
              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                Telefon
              </Grid>
              <Grid item xs={10}>
                <TextField required fullWidth size="small" value={createContactTelefon} onChange={(e) => this.setState({ createContactTelefon: e.target.value })} variant="outlined" />
              </Grid>
              <Grid item xs={2} style={{ paddingTop: '10px'}}>
                eMail
              </Grid>
              <Grid item xs={10}>
                <TextField helperText={!emailValidate ? "eMail ist keine E-Mail-Adresse" : ''} error={emailValidate ? false : true} required fullWidth size="small" value={createContactEmail} onChange={(e) => this.setState({ createContactEmail: e.target.value, emailValidate: true})} variant="outlined" />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button variant="outlined" className="m-10" onClick={this.ValidateContactCustomerForm} color="primary">
              Speichern
            </Button>
            <Button variant="outlined" className="m-10" onClick={this.closeCreateContactDialog} color="secondary">
              Abbrechen
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={isDeleteContactDialogOpen}
        >
          <DialogTitle>Ansprechperson löschen</DialogTitle>
          <DialogContent>
            <DialogContentText >
              Sind Sie sicher?
          </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.deleteContactAndCloseDialog} variant="outlined" size="small" color="primary" autoFocus>
              Bestätigen
          </Button>
            <Button onClick={this.closeDeleteContactDialog} variant="outlined" color="secondary" size='small'>
              Abbrechen
          </Button>
          </DialogActions>
          </Dialog>
          </Container>
      </div>
    )
  }
}
const mapStateToProps = ({ customer, land }) => {
  return {
    isloading: customer.loading,
    error_validation: customer.error_validation,
    deleteSuccess: customer.deleteSuccess,
    customerList: customer.customerList,
    customerContactsList: customer.customerContactsList,
    editedCustomerContact: customer.editedCustomerContact,
    newCustomer: customer.newCustomer,
    editedCustomer: customer.editedCustomer,
    newCustomerContact: customer.newCustomerContact,
    lands_list: land.lands_list,

  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    CreateCustomer: (name, short_name, active, country_id, street, zipcode, city, mail, phone, fax_no, comment) => dispatch(CreateCustomer(name, short_name, active, country_id, street, zipcode, city, mail, phone, fax_no, comment)),
    EditCustomer: (customerId, name, short_name, active, country_id, street, zipcode, city, mail, phone, fax_no, comment) => dispatch(EditCustomer(customerId, name, short_name, active, country_id, street, zipcode, city, mail, phone, fax_no, comment)),
    GetCustomer: () => dispatch(GetCustomer()),
    GetCustomerContacts: () => dispatch(GetCustomerContacts()),
    EditCustomerContact: (customerId, editContactId, editContactFirstName, editContactlastName, editContactActive, editContactAnrede, editContactTitel, editContactFunktion, editContactTelefon, editContactEmail) => dispatch(EditCustomerContact(customerId, editContactId, editContactFirstName, editContactlastName, editContactActive, editContactAnrede, editContactTitel, editContactFunktion, editContactTelefon, editContactEmail)),
    CreateCustomerContact: (customerId, createContactFirstName, createContactlastName, createContactActive, createContactAnrede, createContactTitel, createContactFunktion, createContactTelefon, createContactEmail) => dispatch(CreateCustomerContact(customerId, createContactFirstName, createContactlastName, createContactActive, createContactAnrede, createContactTitel, createContactFunktion, createContactTelefon, createContactEmail)),
    DeleteCustomerContact: (customerContactId) => dispatch(DeleteCustomerContact(customerContactId)),
    LogoutAction: () => dispatch(LogoutAction()),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Customer)
